document.addEventListener("DOMContentLoaded", function() {
  // Initialize Ajaxinate only if the library is available
  if (typeof Ajaxinate !== 'undefined') {
    var endlessScroll = new Ajaxinate({
      method: 'scroll',
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination'
    });
  } else {
    console.warn('Ajaxinate library not loaded. Infinite scroll functionality will not be available.');
  }

  // Function to handle variant selector close
  function handleVariantClose(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const variantFieldset = e.target.closest('.custom-variant-atc');
    if (!variantFieldset) return;
    
    const qtacButton = variantFieldset.closest('product-card').querySelector('.qtac');
    if (!qtacButton) return;
    
    variantFieldset.classList.remove('is-open');
    qtacButton.style.zIndex = 2;

    // Show Gorgias chat and chat button
    const gorgiasChat = document.querySelector('.gorgias-chat-key-1vly0ou');
    if (gorgiasChat) {
      gorgiasChat.style.display = 'block';
    }
    const chatButton = document.getElementById('chat-button');
    if (chatButton) {
      chatButton.style.display = 'block';
    }
  }

  // Add close icon to all variant selectors
  function addCloseIcons() {
    document.querySelectorAll('.custom-variant-atc').forEach(container => {
      // Check if close icon already exists
      if (container.querySelector('.variant-close-icon')) return;
      
      const closeIcon = document.createElement('button');
      closeIcon.className = 'variant-close-icon';
      closeIcon.innerHTML = '×';
      closeIcon.type = 'button';
      closeIcon.addEventListener('click', handleVariantClose);
      container.appendChild(closeIcon);
    });
  }

  // Only add close icons on mobile
  if (window.innerWidth < 989) {
    addCloseIcons();
  }

  // Watch for new product cards being added
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        if (window.innerWidth < 989) {
          addCloseIcons();
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
    }

    bindEvents() {
      this.swatchButtons = this.querySelectorAll('button.options-selector__option.swatch');
      this.swatchButtons.forEach(button => {
        button.addEventListener('click', this.handleSwatchClick.bind(this));
      });

      const showMoreButtons = this.querySelectorAll('.show-more-swatches');
      showMoreButtons.forEach(button => {
        button.addEventListener('click', this.handleShowMore.bind(this));
      });

      const qtacButtons = this.querySelector('.qtac');
      if (qtacButtons) {
        if (window.innerWidth < 989) {
          qtacButtons.addEventListener('click', this.handleQtacClick.bind(this));
        }
      }
    }

    handleShowMore(event) {
      event.preventDefault();
      event.stopPropagation(); // Prevent event bubbling
      
      // Close all other expanded swatch groups first
      document.querySelectorAll('.options-selector.show-all').forEach(selector => {
        if (selector !== event.target.closest('.options-selector')) {
          selector.classList.remove('show-all');
        }
      });

      // Toggle current swatch group
      const optionsBox = event.target.closest('.options-selector');
      optionsBox.classList.toggle('show-all');
    }

    async handleSwatchClick(event) {
      event.preventDefault();
      const swatchButton = event.currentTarget;
      const productUrl = swatchButton.getAttribute('data-product-url');
      const productHandle = productUrl.split('/').pop();

      this.swatchButtons.forEach(button => button.classList.remove('is-active'));
      swatchButton.classList.add('is-active');

      try {
        const response = await fetch(`/products/${productHandle}?view=card`);
        if (!response.ok) throw new Error('Network response was not ok');
        const html = await response.text();

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const newCard = tempDiv.querySelector('product-card');
        
        if (newCard) {
          const customEvent = new CustomEvent('productCardSwatchChange');
          document.dispatchEvent(customEvent);
          const newCardContent = newCard.innerHTML;
          this.innerHTML = newCardContent;

          this.bindEvents();
          setTimeout(() => {
            const form = this.querySelector('form'); 
            if (!form) return;

            const atcButton = form.querySelector('button[type="submit"]'); 

            document.addEventListener('change', (event) => {
              if (event.target.matches('input[name="id"]')) {
                const atcButton = event.target.closest('form')?.querySelector('button[type="submit"]');
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    id: event.target.value
                  })
                })
                .then(response => response.json())
                .then(data => {
                  console.log('Variant added:', data);
                })
                .catch(error => {
                  console.error('Error adding to cart:', error);
                });
              }
            });
          }, 0);
        }
      } catch (error) {
        console.error('Error:', error);
        window.location.href = productUrl; // Fallback to navigation
      }
    }

    handleQtacClick(event) {
      if (window.innerWidth >= 989) return; // Only handle clicks on mobile
      
      event.preventDefault();
      const variantFieldset = this.querySelector('.custom-variant-atc');
      if (!variantFieldset) return;

      this.querySelector('.qtac').style.zIndex = 0;
      variantFieldset.classList.add('is-open');

      // Hide Gorgias chat and chat button
      const gorgiasChat = document.querySelector('.gorgias-chat-key-1vly0ou');
      if (gorgiasChat) {
        gorgiasChat.style.display = 'none';
      }
      const chatButton = document.getElementById('chat-button');
      if (chatButton) {
        chatButton.style.display = 'none';
      }
    }
  }

  customElements.define('product-card', ProductCard);

  // Add click handler for closing expanded swatches when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.options-selector')) {
      document.querySelectorAll('.options-selector.show-all').forEach(selector => {
        selector.classList.remove('show-all');
      });
    }
  });

  const qtacButtons = document.querySelectorAll('.qtac');
  
  qtacButtons.forEach(qtacButton => {
    const variantFieldset = qtacButton.closest('product-form').querySelector('.custom-variant-atc');
    // Click event for the document to reset z-index
    document.addEventListener('click', function(event) {
      if (!variantFieldset.contains(event.target) && !qtacButton.contains(event.target)) {
        qtacButton.style.zIndex = 2; // Reset z-index to 11
        variantFieldset.classList.remove('is-open');
      }
    });
  });

  // Add click handler for closing expanded swatches when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.options-selector')) {
      document.querySelectorAll('.options-selector.show-all').forEach(selector => {
        selector.classList.remove('show-all');
      });
    }
  });

  // Bind mouse over to mega menu
  function bindMouseOverToMegaMenu(item) {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {
        item.setAttribute("open", true);
      });
      item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  }

  // Initialize mega menu bindings
  const megaMenuItems = document.querySelector(".header__inline-menu")?.querySelectorAll("details.mega-menu");
  if (megaMenuItems) {
    megaMenuItems.forEach(bindMouseOverToMegaMenu);
  }
}); 